import type { Character } from "@/features/characters/types";
import type { CharactersStorageAdapter } from "@/features/characters/storage/storage-adapter";

const STORAGE_KEY = "cronicas-arton:characters";

function getLocalCharacters() {
  const raw = window.localStorage.getItem(STORAGE_KEY);

  if (!raw) {
    return [];
  }

  try {
    return JSON.parse(raw) as Character[];
  } catch {
    return [];
  }
}

function setLocalCharacters(characters: Character[]) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(characters));
}

export const localStorageAdapter: CharactersStorageAdapter = {
  async ping() {
    window.localStorage.setItem(`${STORAGE_KEY}:probe`, "ok");
    window.localStorage.removeItem(`${STORAGE_KEY}:probe`);
  },

  async list() {
    return getLocalCharacters();
  },

  async get(id) {
    return getLocalCharacters().find((character) => character.id === id) ?? null;
  },

  async save(character) {
    const characters = getLocalCharacters();
    const index = characters.findIndex((item) => item.id === character.id);

    if (index >= 0) {
      characters[index] = character;
    } else {
      characters.push(character);
    }

    setLocalCharacters(characters);
    return character;
  },

  async delete(id) {
    const characters = getLocalCharacters().filter((character) => character.id !== id);
    setLocalCharacters(characters);
  },

  async clear() {
    window.localStorage.removeItem(STORAGE_KEY);
  },
};
